import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import SlopeSection from './SlopeSection/SlopeSection';
import GroupedBarSection from './GroupedBarSection/GroupedBarSection';

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    padding: '0 30px',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  intro: {
    fontSize: '1.125em',
  },
  introText: {
    maxWidth: 700,
  },
  cta: {
    backgroundColor: '#BE7999',
    padding: '10px 15px',
    borderRadius: 3,
    width: '100%',
    maxWidth: 270,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#955e78',
    },
  },
  ctaText: {
    display: 'block',
    fontSize: '0.7em',
    paddingTop: 10,
    maxWidth: 270,
  },
  gridItmBubble: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0 !important',
    },
  },
  gridItmTopJournalists: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0 !important',
    },
    '@media (min-width: 1100px)': {
      paddingLeft: '102px !important',
    },
  },
}));

const Comparison = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">

      <Box className={classes.groupedBar}>
        <GroupedBarSection
          header="=Only({<Index = {70}>}[$(vLanguage)])"
          text="=Only({<Index = {71}>}[$(vLanguage)])"
        />
      </Box>

      <Box className={classes.slope}>
        <SlopeSection
          header="=Only({<Index = {72}>}[$(vLanguage)])"
          text="=Only({<Index = {73}>}[$(vLanguage)])"
        />
      </Box>

    </Container>
  );
};

Comparison.propTypes = {};

export default Comparison;
